import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    
    button: {
        padding: '0.3rem 1rem',
        fontSize: '12px',
        marginRight: '10px',
        whiteSpace: 'nowrap',
    },
    select: {
        minWidth: 50,
        maxWidth: 400,
        width: '100%',
        textOverflow: 'ellipsis',
        height: 30,
    },
    unSelected: {
        color: theme.palette.grey[500],
    },
    buttonMargin: {
        margin: '0 12px',
    },
    configColumnTypography: {
        fontWeight: 'lighter',
      },
    itemTitleTypography: {
        fontWeight: 'bold',
        fontSize:"14px",
      },
      configTitleTypography: {
        fontWeight: 'lighter',
      },
      iconMargin:{
        paddingBottom:  '4px',
      },
}));

export default useStyles;
